import { render, staticRenderFns } from "./printCredentials.vue?vue&type=template&id=3f5ab3c4&scoped=true&"
import script from "./printCredentials.vue?vue&type=script&lang=js&"
export * from "./printCredentials.vue?vue&type=script&lang=js&"
import style0 from "./printCredentials.vue?vue&type=style&index=0&id=3f5ab3c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5ab3c4",
  null
  
)

export default component.exports